import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { AmendmentTypes, PayrunTypes } from '@xemplo/gp-types';

import { FormFields } from '../../create-amendment.types';

import { EffectiveDate } from './page-1/adhoc-effective-date';
import { PayDate } from './page-1/adhoc-pay-date';
import { ChangeType } from './page-1/change-type';
import { PayrunType } from './page-1/payrun-type';
import { SelectPayrun } from './page-1/select-payrun';

export function StepOne() {
  const { control } = useFormContext<FormFields>();
  const changeType = useWatch({ control, name: 'changeType' });
  const payrunType = useWatch({ control, name: 'payrunType' });

  const showSelectPayrun = useMemo(
    () => changeType === AmendmentTypes.PAYRUN && payrunType === PayrunTypes.SCHEDULED,
    [changeType, payrunType],
  );

  const showDates = useMemo(
    () => changeType === AmendmentTypes.PAYRUN && payrunType === PayrunTypes.ADHOC,
    [changeType, payrunType],
  );

  return (
    <>
      <ChangeType />
      {changeType === AmendmentTypes.PAYRUN && <PayrunType />}
      {showSelectPayrun && <SelectPayrun />}
      {showDates && (
        <>
          <EffectiveDate />
          <PayDate />
        </>
      )}
    </>
  );
}
